import { render, staticRenderFns } from "./IconBetaDocuments.vue?vue&type=template&id=18b3b300&"
import script from "./IconBetaDocuments.vue?vue&type=script&lang=ts&"
export * from "./IconBetaDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports